import React, { useEffect, useState } from 'react';

import { Add } from '@mui/icons-material';
import {
  Button,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  Box,
} from '@mui/material';
import { useFormikContext } from 'formik';
import { Link } from 'react-router-dom';
import OneTimeAutocompleteSearch from 'views/I9/components/OneTimeAutocompleteSearch';
import StringToCheckBoxGroup from 'views/I9/components/StringToCheckBoxGroup';
import mandats from 'views/I9/resources/mandats';

import AutocompleteSearch from '../../components/AutocompleteSearch';
import ResourceList from '../../components/ResourceList';
import axios from '../../modules/axios';
import ApporteParAutoComplete from './ApporteParAutoComplete';

export const CONTACT_PREFERENCES_LIST = ['Mail', 'Contact tel', 'Extranet'];
const STOCK_INFORMATION_CONTACTS = ['24854,33079,32682,19642,2216'];

export default () => {
  const { values, handleChange, setValues, setFieldValue } = useFormikContext();

  const [statuts, setStatuts] = useState([]);
  const [dpDuplicateFields, setDpDuplicateFields] = useState('');

  useEffect(() => {
    axios.get('prog_statut?prog_statut_deleted=0').then(res => {
      setStatuts(res.data);
    });
  }, []);

  const optionLabel = option => `${option.nom} ${option.prenom}${option.email_pro && ' - ' + option.email_pro}`;

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography variant='h6'>Nom</Typography>
      </Grid>
      <Divider />
      <Grid item xs={4}>
        <TextField
          fullWidth
          size='small'
          name='nom'
          label='Nom'
          value={values.nom}
          onChange={handleChange}
          variant='outlined'
        />
      </Grid>
      <Grid item xs={4}>
        <TextField
          fullWidth
          size='small'
          name='initiales'
          label='Initiales'
          value={values.initiales}
          onChange={handleChange}
          variant='outlined'
        />
      </Grid>
      <Grid item xs={4}>
        <FormControl fullWidth variant='outlined' size='small'>
          <InputLabel>Statut</InputLabel>
          <Select label='Statut' value={values.visibilite} onChange={handleChange} name='visibilite'>
            {statuts.map(statut => (
              <MenuItem key={statut.prog_statut_id} value={statut.prog_statut_visibilite}>
                {statut.prog_statut_long_name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <Typography variant='h6'>Memo</Typography>
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          multiline
          size='small'
          rows={4}
          name='memo'
          label='Memo'
          value={values.memo || ''}
          onChange={handleChange}
          variant='outlined'
        />
      </Grid>
      <Grid item xs={12}>
        <Typography variant='h6'>Blocage</Typography>
      </Grid>
      <Grid item xs={6} sm={4}>
        <FormControlLabel
          control={<Checkbox checked={values.passerelle_block} onChange={handleChange} name='passerelle_block' />}
          label='Blocage passerelle'
        />
      </Grid>
      <Grid item xs={6} sm={4}>
        <FormControlLabel
          control={<Checkbox checked={values.prom_refuse_pub} onChange={handleChange} name='prom_refuse_pub' />}
          label='Interdiction de puber'
        />
      </Grid>
      <Grid item xs={12} sm={4} />
      <Grid item xs={12}>
        <Typography variant='h6'>Facturation</Typography>
      </Grid>
      <Divider />
      <Grid item xs={12}>
        <TextField
          fullWidth
          size='small'
          name='entite_facturation'
          label='Entité facturation'
          value={values.entite_facturation}
          onChange={handleChange}
          variant='outlined'
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          multiline
          size='small'
          rows={3}
          name='adresse_facturation'
          label='Adresse facturation'
          value={values.adresse_facturation}
          onChange={handleChange}
          variant='outlined'
        />
      </Grid>
      {values.idmandat ? (
        <>
          <Grid item xs={12}>
            <Typography variant='h6'>Mandat</Typography>
          </Grid>
          <Grid item xs={12}>
            <Button variant='contained' color='secondary' onClick={() => setFieldValue('idmandat', 0)}>
              Choisir un autre mandat
            </Button>
            <ResourceList
              {...mandats}
              remove={false}
              add={false}
              filter={null}
              options={{
                idmandat: values.idmandat,
              }}
            />
          </Grid>
        </>
      ) : (
        values.idpromoteur !== 0 && (
          <>
            <Grid item xs={12}>
              <Typography variant='h6'>Mandat Cadre</Typography>
            </Grid>
            <Grid item xs={12}>
              <ResourceList
                {...mandats}
                title='Mandat cadre'
                query={{ _associations: 'avenants,type,promoteur' }}
                strictFilters
                filters={{
                  idpromoteur: values.idpromoteur,
                  mandat_commercialisation_mandat_type_id: 1,
                  mandat_commercialisation_deleted: 0,
                  mandat_commercialisation_idmandat: 0,
                }}
                select={selected => setFieldValue('idmandat', selected[0]?.idmandat)}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant='h6'>Mandat Programme</Typography>
            </Grid>
            <Grid item xs={12}>
              <ResourceList
                title='Mandat programme'
                {...mandats}
                query={{ _associations: 'avenants,type,promoteur,mandat_prog' }}
                strictFilters
                filters={{
                  idpromoteur: values.idpromoteur,
                  mandat_commercialisation_mandat_type_id: 2,
                  mandat_commercialisation_deleted: 0,
                  mandat_commercialisation_idmandat: 0,
                  'mandat_prog.mandat_prog_idprog': values.id,
                }}
                select={selected => setFieldValue('idmandat', selected[0]?.idmandat)}
              />
            </Grid>
          </>
        )
      )}
      <Grid item xs={12}>
        <Typography variant='h6'>Notaire</Typography>
      </Grid>
      <Grid item xs={6}>
        <AutocompleteSearch
          resource='notaire'
          attributeId='idnotaire'
          attribute='nom'
          label='Notaire'
          optionLabel={option => option.nom + ' ' + option.prenom + ' - ' + option.email + ' - ' + option.cp}
          value={values.idnotaire}
          onChange={(event, value) => value && setFieldValue('idnotaire', value.idNotaire)}
          size='small'
          filters={{ _fields: 'nom,prenom,email,cp,idNotaire' }}
        />
      </Grid>
      <Grid item xs={6}>
        <Link to={{ pathname: `/i9/notaires` }} target='_blank'>
          <Button variant='contained' color='primary'>
            <Add />
          </Button>
        </Link>
      </Grid>
      <Grid item xs={12}>
        <Typography variant='h6'>Interface délégué programme</Typography>
      </Grid>
      {!values.idpromoteur && (
        <Grid item xs={12}>
          <Typography variant='body1' color='error'>
            Veuillez sélectionner un promoteur avant d'éditer les champs suivants.
          </Typography>
        </Grid>
      )}
      <Grid item xs={6}>
        <AutocompleteSearch
          resource='individu'
          attributeId='idindividu'
          optionLabel={optionLabel}
          attribute='nom'
          sort='nom'
          value={values.responsable_prog}
          label='Responsable programme'
          onChange={(event, value) => value && setValues({ ...values, responsable_prog: value.idindividu })}
          size='small'
          disabled={!values.idpromoteur}
          filters={{ idpromoteur: values.idpromoteur, delete: 0, _fields: 'nom,prenom,email_pro,idindividu' }}
        />
      </Grid>
      <Grid item xs={6}>
        <AutocompleteSearch
          resource='individuPartenaire'
          attributeId='idindividu'
          associations='*individu'
          optionLabel={({ individu }) => individu.nom + ' ' + individu.prenom + ' - ' + individu.email}
          fetchRemote={false}
          value={values.admin_ventes}
          label='Administrateur des ventes'
          sort='individu.nom'
          onChange={(event, value) => value && setValues({ ...values, admin_ventes: value.idindividu })}
          size='small'
          filters={{
            idpartenaire: [0, 1, 2, 3, 4, 5],
            'individu.delete': 0,
            _groupBy: 'individu.idindividu',
            _fields: 'idindividu',
            'individu._fields': 'nom,prenom,email',
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <AutocompleteSearch
          resource='individu'
          attributeId='idindividu'
          optionLabel={option =>
            `${option.nom} ${option.prenom}${option.tel_pro && ' - ' + option.tel_pro} ${
              option.email_pro && ' - ' + option.email_pro
            }`
          }
          attribute='nom'
          sort='nom'
          value={values.administrateur_ventes}
          label='Administrateur ventes / Comptabilité &amp; règlement'
          onChange={(event, value) => value && setValues({ ...values, administrateur_ventes: value.idindividu })}
          size='small'
          disabled={!values.idpromoteur}
          filters={{ idpromoteur: values.idpromoteur, delete: 0, _fields: 'nom,prenom,email_pro,tel_pro,idindividu' }}
        />
      </Grid>
      <Grid item xs={6}>
        <AutocompleteSearch
          resource='individu'
          attributeId='idindividu'
          optionLabel={optionLabel}
          attribute='nom'
          sort='nom'
          value={values.responsable_gestion_financiere}
          label='Contact pour les dénonces'
          onChange={(event, value) =>
            value && setValues({ ...values, responsable_gestion_financiere: value.idindividu })
          }
          size='small'
          disabled={!values.idpromoteur}
          filters={{ idpromoteur: values.idpromoteur, delete: 0 }}
        />
        <Box pt={2}>
          <StringToCheckBoxGroup
            label='Préférences de contact'
            stringValues={values.contact_denonce_type || '000'}
            name='contact_denonce_type'
            items={CONTACT_PREFERENCES_LIST}
            setFieldValue={setFieldValue}
          />
        </Box>
      </Grid>
      <Grid item xs={6}>
        <AutocompleteSearch
          resource='individu'
          attributeId='idindividu'
          optionLabel={optionLabel}
          attribute='nom'
          sort='nom'
          value={values.charge_receptions_lots}
          label='Contact pour les options'
          onChange={(event, value) => value && setValues({ ...values, charge_receptions_lots: value.idindividu })}
          size='small'
          disabled={!values.idpromoteur}
          filters={{ idpromoteur: values.idpromoteur, delete: 0 }}
        />
        <Box pt={2}>
          <StringToCheckBoxGroup
            label='Préférences de contact'
            stringValues={values.contact_reservation_type || '000'}
            name='contact_reservation_type'
            items={CONTACT_PREFERENCES_LIST}
            setFieldValue={setFieldValue}
          />
        </Box>
      </Grid>
      <Grid item xs={6}>
        <AutocompleteSearch
          attributeId='individu_centrale_idindividu'
          resource='individu_centrale'
          associations='*individu'
          attribute='individu.nom'
          sort='individu.nom'
          optionLabel={option =>
            option?.individu?.nom + ' ' + option?.individu?.prenom + ' - ' + option?.individu?.email_pro
          }
          value={values.delegue_promoteur}
          label='Délégué programme'
          onChange={(_, value) => {
            if (value) {
              setValues({
                ...values,
                delegue_promoteur: value.individu_centrale_idindividu,
                idlitige_dif: value.individu_centrale_idindividu,
                strategie_vente: value.individu_centrale_idindividu,
              });
            } else {
              setValues({ ...values, delegue_promoteur: null, idlitige_dif: null, strategie_vente: null });
            }
          }}
          onInputChange={(_, value) => setDpDuplicateFields(value || '')}
          size='small'
          filters={{ individu_centrale_isDp: 1, 'individu.delete': 0 }}
        />
      </Grid>
      <Grid item xs={6}>
        <ApporteParAutoComplete
          initialValue={values.apporte_par}
          onChange={(_, value) => setValues({ ...values, apporte_par: value ? value.idindividu : 0 })}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          label='Responsable interne litiges'
          value={dpDuplicateFields}
          size='small'
          variant='outlined'
          disabled
          fullWidth
        />
        <Box marginY={3}>
          <TextField
            label='Relation promoteur'
            value={dpDuplicateFields}
            size='small'
            variant='outlined'
            disabled
            fullWidth
          />
        </Box>
      </Grid>
      <Grid item xs={6}>
        <OneTimeAutocompleteSearch
          resource='individu'
          sort='nom,prenom'
          attributeId='idindividu'
          optionLabel={option => option.nom + ' ' + option.prenom + ' - ' + option.email_pro}
          value={values.idresp_dif}
          label='Réception info option/résa'
          onChange={(event, value) => value && setFieldValue('idresp_dif', value.idindividu)}
          size='small'
          filters={{ idindividu: STOCK_INFORMATION_CONTACTS, delete: 0, _fields: 'idindividu,nom,prenom,email_pro' }}
        />
        <Box marginY={3}>
          <OneTimeAutocompleteSearch
            resource='individu'
            sort='nom,prenom'
            attributeId='idindividu'
            optionLabel={option => option.nom + ' ' + option.prenom + ' - ' + option.email_pro}
            value={values.idresp_denonce}
            label='Réception dénonces contacts'
            onChange={(event, value) => value && setFieldValue('idresp_denonce', value.idindividu)}
            size='small'
            filters={{
              idindividu: STOCK_INFORMATION_CONTACTS,
              delete: 0,
              _fields: 'idindividu,nom,prenom,email_pro',
            }}
          />
        </Box>
      </Grid>
    </Grid>
  );
};
